import React from 'react';

function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2 className="section-title">CONTACT</h2>
        <div className="contact-content">
          <p>For inquiries, submissions, and general information:</p>
          <a href="mailto:holymountaun@gmail.com" className="contact-email">holymountaun@gmail.com</a>
        </div>
      </div>
    </section>
  );
}

export default Contact;

